import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IImageFeatureWithLinkProps } from '../components/image-feature-with-link/image-feature-with-link';

export class ImageFeatureWithLink extends ContentItem {
  get imageSize(): string {
    return get(this._config, 'elements.image_size.value[0].codename', '');
  }

  get imgAsset(): string {
    return get(this._config, 'elements.img_asset.value[0].url', '');
  }

  get linkToExternal(): string | undefined {
    return get(this._config, 'elements.link_to_external.value', undefined);
  }

  get linkToInternal(): string | undefined {
    return get(this._config, 'elements.link_to_internal.value', undefined);
  }

  get scrollToSection(): string | undefined {
    return get(this._config, 'elements.scroll_to_section.value', undefined);
  }

  get customHeight(): number {
    return get(this._config, 'elements.custom_height.value', null);
  }

  get withBorder(): boolean {
    return (
      get(this._config, 'elements.with_border.value[0].codename') === 'true'
    );
  }

  get hasGrayscaleFilter(): boolean {
    return (
      get(this._config, 'elements.has_grayscale_filter.value[0].codename') ===
      'true'
    );
  }

  get opacity(): number {
    return get(this._config, 'elements.opacity.value', 100);
  }

  public static create(
    data: IImageFeatureWithLink
  ): IImageFeatureWithLinkProps {
    const {
      imageSize,
      imgAsset,
      linkToExternal,
      linkToInternal,
      withBorder,
      hasGrayscaleFilter,
      opacity,
      customHeight,
      scrollToSection
    } = new ImageFeatureWithLink(data);
    return {
      imageSize,
      imgAsset,
      linkToExternal,
      linkToInternal,
      withBorder,
      hasGrayscaleFilter,
      opacity,
      customHeight,
      scrollToSection
    };
  }
}
